/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import Container from 'saur_ui_library/src/Atoms/Container/Container';
import Word from 'saur_ui_library/src/Atoms/Word/Word';
import Error from '../../components/common/ErrorMessage';
import { dataService2, getAllMeasures, reformatDate, showHideGraphics } from '../../utils/helpers/view/detailsHelper';
import SearchDate from '../../components/common/SearchDate';
import { createGlobalStyle } from 'styled-components';
import { InputSwitch } from 'primereact/inputswitch';
import { LocalStorage } from '../../utils/localStorage';
import { DoTpDetailApi } from '../../utils/api';
import { fetchPov } from '../DetailHelper';
import { DoTpGraphicsContainer } from '../../utils/helpers/view/doTpDetailHelper';
import { getLastDebitMeasure } from '../../utils/helpers/view/PrDoDetailHelper';
import { pluvioInterface } from '../H2SParam/Interface';
import ResetStyleComponent from '../../components/cssSaur/resetStyleComponent';

const DoTpDetail = () => {
  //Variables
  const [showPluvio, setShowPluvio] = useState<boolean>(false);
  const [lastError, setError] = useState(false);
  const [doName, setDoName] = React.useState('');
  const [code] = useState(window.sessionStorage.getItem('Code'));
  const type = window.localStorage.getItem('type')!;
  const [debit, setDebit] = React.useState<any>();
  const [reziseGraphics, setResizeGraphics] = useState<any>({
    'dataTemps-chart': 'block',
    'dataNombre-chart': 'block',
    'dataVolume-chart': 'block',
  });
  const [displayHeader, setDisplayHeader] = React.useState<string>('block');
  const [dataSelected, setDataSelected] = React.useState<any>(pluvioInterface.filter((p) => p.id === 3)[0]);
  const [allMeasures, setAllMeasures] = React.useState<any>(null);
  // pluvie variables
  const [idPov, setIdPov] = useState<string | null>(null);

  //Set service error
  dataService2.getError().subscribe((errorState: any) => {
    setError(errorState);
  });

  const doType = window.localStorage.getItem('DoName');

  const handleShowHideGraphics = (pGraphicToGrow: string, pMode: string) => {
    setResizeGraphics(showHideGraphics(pGraphicToGrow, pMode));
    setDisplayHeader(pMode === 'hide' ? 'none' : 'block');
  };

  const getDataForGraphics = async (pDates: any) => {
    setAllMeasures(null);
    setDebit(null);
    try {
      getAllMeasures(
        DoTpDetailApi,
        type,
        window.sessionStorage.getItem("Code"),
        reformatDate(pDates.start),
        reformatDate(pDates.end),
      ).then((responseAllMeasures: any) => {
        setAllMeasures(responseAllMeasures.data);
      });
      getLastDebitMeasure(code, DoTpDetailApi, setDebit);
    } catch(e){
      console.log(e);
    }
  };

  useEffect(() => {
    const name = LocalStorage.doName.get();
    if (name !== null) {
      setDoName(name.toString());
    }
    fetchPov(code).then((pov) => setIdPov(pov));
  }, []);

  return (
    <>
      <Container className='sds-reset-style global-do-container'>
        <ResetStyleComponent />
        {lastError ? <Error IsVisible={lastError}></Error> : null}
        <Styles />
        <Word
          textStyle='title'
          automatedTestId='global-do-name'
          variant='h1'
          value={doName.toUpperCase()}
        />
        <div style={{ display: displayHeader, alignItems: 'center' }}>
          <div className='search-detail-do'>
            <SearchDate
              sendDates={getDataForGraphics}
            />

            <div className="pov-info">
              <Word
                textStyle='normalReg'
                variant='span'
                value={idPov ? 'POV :' : ''}
              />
              <Word
                textStyle='normalBold'
                variant='span'
                value={idPov ? idPov.toString() : ''}
              />
            </div>

            <InputSwitch
              className='pluvio-switch'
              id='pluvio-switch'
              checked={showPluvio}
              onChange={(e) => {
                if(e.value === true) {
                  setDataSelected(pluvioInterface.filter((d) => d.id === 1)[0]);
                  setShowPluvio(true);
                } else {
                  setDataSelected(pluvioInterface.filter((d) => d.id === 3)[0]);
                  setShowPluvio(false);
                }
              }}
            />
            <Word
              value='Pluviométrie'
              textStyle='title'
              variant='p'
              automatedTestId='pr-pluvio'
            />
          </div>
          <Container className='pompe-info'>
            <Word
              textStyle='normalReg'
              automatedTestId='pompe-derniere-remontee'
              variant='p'
              value={debit ? 'Dernière remontée :' : ''}
            />
            <Word
              textStyle='normalBold'
              automatedTestId='pompe-date'
              variant='p'
              value={debit ? new Date (debit?.time).toLocaleDateString() : ''}
            />
          </Container>
        </div>

        {/* temp and number graphics */}
        {
          <>
            <DoTpGraphicsContainer
              data={{ allMeasures }}
              module={doType}
              code={code}
              dataSelected={dataSelected}
              handleShowHideGraphics={handleShowHideGraphics}
              showHide={reziseGraphics}
            />
          </>
        }
      </Container>
    </>
  );
};

export const Styles = createGlobalStyle`
  .sds-reset-style .loaderDoTpGraphics {
    width: 48px;
    height: 48px;
    border: 5px solid #FFF;
    border-bottom-color: #243977;
    border-radius: 50%;
    display: inline-block;
    box-sizing: border-box;
    animation: rotation 1s linear infinite;
    }

    @keyframes rotation {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
  }
  .global-do-container{
    margin-top: 5px;
    margin-left: 34vh;
    margin-right: auto;
    .search-detail-do{
      flex-direction: row;
      display: inline-flex;
      gap: 10px;
      align-items: center;
    }
  }
  .pompe-info{
    flex-direction: row;
    margin-bottom: 10px;
    .warning{
      flex-direction: row; 
    }
    #warning-text{
      margin-left:5px;
      color:#FE3123
    }
    .warning-logo{
      margin-left:20px;
    }
    #pompe-derniere-remontee{
      margin-right: 5px;
    }
    #pompe-q{
      margin-right: 5px;
    }
  }
  .pov-info {
    display: flex;
    align-items: center;
    gap: 5px;
    margin-left: 30px;
  }  
  .p-inputswitch{
    width: 48px;
    height: 28px;
   .p-inputswitch-slider:before {
    width: 20px;
    height: 20px;
    left: 4px;
    margin-top: -10px;
    }
  }
  .p-inputswitch.p-inputswitch-checked .p-inputswitch-slider:before {
    -webkit-transform: translateX(18px);
    transform: translateX(18px);
  }
`;
export default DoTpDetail;
